import { render } from "./subscribe.vue?vue&type=template&id=8d39d740&scoped=true"
import script from "./subscribe.vue?vue&type=script&lang=js"
export * from "./subscribe.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-8d39d740"

export default script